import React, { useState, useEffect } from 'react';
import defaultAxios from 'axios';
import { useNavigate } from 'react-router-dom';
import { backendUrl } from '../common/constantVarialble';

const SearchModal = ({ onClose, onSearch }: { onClose: () => void, onSearch: (searchTerm: string) => void }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    const handleKeyDown = async (e: any) => {
        if (e.key === 'Enter') {
            //onSearch(searchTerm);
            const result = await getProgramIDInfo(searchTerm);

            // ProgramID가 존재하는 경우
            if (result && result.ok && result.data.length > 0) {
                // navigate(?program_ID)
                navigate(`/admin/sql/program?program_id=${searchTerm}`);
                onClose();
            } else {
                // 존재하지 않는 프로그램 ID
                alert("Not Existing Program Id")
            }
        }
    };

    const handleClickOutside = (e: any) => {
        if (!e.target.closest('.modal-content')) {
            onClose();
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [handleClickOutside]);

    const getProgramIDInfo = async (program_id: string) => {
        try {
            if (!program_id.trim()) return;

            const { data } = await defaultAxios({
                method: 'post',
                //url: 'http://localhost:5000/api/request/',
                url: backendUrl,
                data: {
                    program_id: 'PERCENT-ADMIN-PRG-L-LSTSQLBYPROGRAMID',
                    params: {
                        'program_id': program_id.trim(),
                    },
                    page_index: -1,
                },
            });

            return data;

        } catch (error) {
            console.error(error);
            return null;
        }
    }


    const onSearchButtonClick = async (searchTerm: string) => {
        const result = await getProgramIDInfo(searchTerm);
        console.log("searchButton Click result");
        console.log(result);
        // ProgramID가 존재하는 경우
        if (result && result.ok && result.data.length > 0) {
            // navigate(?program_ID)
            navigate(`/admin/sql/program?program_id=${searchTerm}`);
            onClose();
        } else {
            // 존재하지 않는 프로그램 ID
            alert("Not Existing Program Id")
        }
    }

    return (

        <div className="fixed inset-0 -top-96 bg-gray-800 bg-opacity-75 left-0 flex items-center justify-center z-50" >
            <div className="bg-gray-700 p-6 rounded-lg modal-content">
                <input
                    type="text"
                    placeholder="Search for PROGRAM ID"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onKeyDown={handleKeyDown}
                    className="focus:border-teal-500 mr-8 p-2 rounded-xl appearance-none" style={{ width: "65vw" }}
                />


                <button className="px-4 py-2 group relative overflow-hidden rounded-lg justify-center bg-indigo-400 text-body font-bold" onClick={() => onSearchButtonClick(searchTerm)}>
                    Search
                    <div className="absolute inset-0 h-full w-full scale-0 rounded-2xl transition-all duration-300 group-hover:scale-100 group-hover:bg-white/30"></div>
                </button>


            </div>
        </div>
    );
};

export default SearchModal;